import { createContext, useContext } from 'react';

import type { LevelSetCardItem } from 'bundles/levelsets/levelsets-v2/types';

export type EnterpriseLevelSetsContextType = {
  levelSets: LevelSetCardItem[];
  levelSetsLoading?: boolean;
  hasError: boolean;
};

const EnterpriseLevelSetsContext = createContext<EnterpriseLevelSetsContextType>({
  levelSets: [],
  levelSetsLoading: false,
  hasError: false,
});

export const useEnterpriseLevelSets = () => useContext(EnterpriseLevelSetsContext);

export default EnterpriseLevelSetsContext;
